import { useState, useEffect } from 'react';
import moment from 'moment';
import { Form, Input, Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import successImg from '../../images/Haleon/checkmark.png';
import SubHeader from '../../components/SubHeader';
import './profile.css';
import axiosClient from '../../utils/axiosClient';
import UserFooter from '../../components/UserFooter';

const PersonalDetails = ({ t }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [form] = Form.useForm();
	const [disableSubmit, setDisableSubmit] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);
	const [errorEmail, setErrorEmail] = useState();
	const [errorName, setErrorName] = useState();
	const [errorNumber, setErrorNumber] = useState();
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [number, setNumber] = useState('');
	const [errorMsg, setErrorMsg] = useState('');
	const [errorDob, setErrorDob] = useState();
	const [error, setError] = useState();
	const [userData, setUserData] = useState();

	const onFinish = async (values) => {
		try {
			setDisableSubmit(true);
			const res = await axiosClient.post('/profile/update', {
				values: { ...values },
			});
			if (res) {
				setIsSuccess(true);
			}
		} catch (err) {
			console.log('error', err);
		}
	};

	useEffect(() => {
		

		const checkUserInfo = async () => {
			try {
				const res = await axiosClient.get('/users/details');
				setUserData(res.data.data.personalInfo);
				// console.log(res);
			} catch (error) {
				setError(error.res.data.error);
				console.log('error', error);
			}
		};
		checkUserInfo();
	}, []);

	useEffect(() => {
		
		
		if (userData) {
			form.setFieldsValue({
				name: userData?.name,
				email: userData?.email,
				phone: userData?.phone,
				dob: userData?.dob
				? moment(userData.dob).format('yyyy-MM')
				: userData?.extendedFields?.birthdate
				? moment(userData?.extendedFields?.birthdate).format('yyyy-MM')
				: null,
			});
		}
	}, [userData]);

	useEffect(() => {
		if (errorEmail || errorName || errorNumber || errorDob) setDisableSubmit(true)
			else setDisableSubmit(false);
	}, [errorEmail, errorName, errorNumber, errorDob])


	const isName = (e) => {
		var regex = /^[a-zA-Z ]+( [a-zA-Z ]+)*$/;
		// /^[a-zA-Z]+(?:\s[a-zA-Z]+)+$/;

		setName(e.target.value);

		if(e.target.value.length > 50)	return setErrorName("Name cannot be more than 50 characters")
					
		if (!regex.test(e.target.value)) return setErrorName('Invalid name format');
		else return setErrorName();		
	};


	const isEmail = (e) => {
		setEmail(e.target.value);

		// eslint-disable-next-line no-useless-escape
		let regEmail = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;

		if(e.target.value.length > 50)	return setErrorEmail("Email cannot be more than 50 characters")

		if (!regEmail.test(e.target.value))	return setErrorEmail('Invalid email format');
		else return setErrorEmail();
		
	};

	return (
		<div >
			<UserFooter type={'profilePage'}/>
			<SubHeader setPreviousPage={'/profile'} />
			<div className="mt-1">
				<hr />
			</div>

			<div className="ml-2 mr-2">
				<div className="mt-2">
					<p style={{ fontWeight: '500', fontSize: '24px' }}>
						{t('Personal Details')}
					</p>
				</div>

				<div>
					<div className="mx-5">
						<Form
							layout="vertical"
							name="register"
							form={form}
							onFinish={onFinish}
							autoComplete="off"
						>
							<div className="mt-2">
								<Form.Item
									name="name"
									label={
										<label className="form-item-label" style={{fontSize: '16px'}}>
											{' '}
											{t('Full Name')}
										</label>
									}
									rules={[
										{
											// required: true,
											message: t('inputName'),
										},
									]}
								>
									<Input
										type="text"
										placeholder={t('fullName')}
										onChange={isName}
									/>
								</Form.Item>
								{errorName ? (
									<>
										{' '}
										<div
											style={{
												color: 'red',
												marginTop: '-5%',
												textAlign: 'left',
											}}
										>
											{errorName}
										</div>
										<br />
									</>
								) : null}

								<Form.Item
									name="email"
									label={
										<label className="form-item-label"  style={{fontSize: '16px'}}>
											{t('Email Address')}
										</label>
									}
									rules={[
										{
											required: true,
											message: t('Email Address required'),
										},
									]}
									style={{ color: 'red' }}
								>
									<Input
										type="email"
										placeholder="Enter email Address"
										onChange={isEmail}
									/>
								</Form.Item>
								{errorEmail ? (
									<>
										{' '}
										<div
											style={{
												color: 'red',
												marginTop: '-5%',
												textAlign: 'left',
											}}
										>
											{errorEmail}
										</div>
										<br />
									</>
								) : null}
								<Form.Item
									name="phone"
									label={
										<label className="form-item-label" style={{fontSize: '16px', fontFamily: 'Hero New'}}>
											{' '}
											{t('Phone Number')}
										</label>
									}
								>
									<Input
										type="number"
										placeholder="Enter your phone number"
										// onChange={isNumber}
										disabled
									/>
								</Form.Item>
								{errorNumber ? (
									<>
										{' '}
										<div
											style={{
												color: 'red',
												marginTop: '-5%',
												textAlign: 'left',
											}}
										>
											{errorNumber}
										</div>
										<br />
									</>
								) : null}

								<Form.Item
									name="dob"
									label={
										<label className="form-item-label"  style={{fontSize: '16px'}}>{t('Month of Birth')}</label>
									}
								>
									<Input max={new Date().toISOString().slice(0, 7)} type="month" className="input-type-month" style={{ width: '100%' }} />
								</Form.Item>
								<Form.Item style={{padding: '15px 0 100px 0'}}>
								<Button
							disabled={disableSubmit}

									// loading={loading}
									htmlType="submit"
									className="save-btn"
								>
									{t('Save')}
								</Button>
								</Form.Item>
							</div>
							{errorMsg ? (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
										textAlign: 'center',
									}}
								>
									{errorMsg}
								</p>
							) : null}
							
						</Form>
					</div>
				</div>

				<div>
					<Modal
						open={isSuccess}
						centered
						header={null}
						footer={null}
						onCancel={() => setIsSuccess(false)}
						closable={false}
						width={330}
					>
						<div className="text-center">
							<img
								style={{ width: '20%' }}
								src={successImg}
								alt=""
								className="submit-success-icon"
							></img>
							<div className="update-details-success-header" style={{fontSize: '24px', fontFamily: 'Hero New'}}>{t('Success')}!</div>
							<div className="mt-1 w-100">
								<p className="text-center">
									{t('Your details have been successfully updated')}.
								</p>
							</div>
							<Button
								className="receipt-success-button mt-1"
								style={{ backgroundColor: '#02BC7D', fontSize: '16px', fontFamily: 'Hero New'}}
								onClick={() => navigate('/profile')}
							>
								{t('Done')}
							</Button>
						</div>
					</Modal>
				</div>
			</div>

			<div style={{ justifyContent: 'center', display: 'flex' }}>
				<UserFooter type={'profilePage'} />
			</div>
		</div>
	);
};

export default PersonalDetails;
